import {UserPreferenceType} from '../../constants/actionType';

// eslint-disable-next-line import/prefer-default-export
export const setFavoriteLabwareIDs = (data) => ({type: UserPreferenceType.SET_FAVORITE_LABWARE_IDS, data});
